<ng-container *ngIf="report">
    <app-quarterly-report-html-to-pdf [report]="report"></app-quarterly-report-html-to-pdf>
</ng-container>
